import React, { useEffect, useState } from "react";
import { BsArrowLeft, BsHeart } from "react-icons/bs";
import styled from "styled-components";
const DetailsCard2 = ({ ingredientsList, recipe, setShowDetails }) => {
  const [cleanedIngredientList, setCleanedIngredientList] = useState([]);
  useEffect(() => {
    const tempIng = ingredientsList.filter(
      (ing) =>
        ing !== "" && ing !== " " && !ing.toLowerCase().includes("ingredient")
    );
    setCleanedIngredientList([...tempIng]);
  }, [ingredientsList]);
  const YoutubeUrl = `https://www.youtube.com/results?search_query=${recipe.recipeName.replace(
    /\s/g,
    "%2B"
  )}`;
  console.log(YoutubeUrl);
  const WhatsappMessage = `Hey, Lets have *${
    recipe.recipeName
  }* together.%0a*Ingredients:* %0a${cleanedIngredientList.join(
    "%0a"
  )}%0a*Recipe Link*: ${YoutubeUrl}`;
  return (
    <Container>
      <Head>
        <BackButton onClick={() => setShowDetails(false)}>
          <BsArrowLeft strokeWidth="1.5" />
        </BackButton>
        <span>Kaise Banega</span>
        <BsHeart strokeWidth="1.5" />
      </Head>
      <Body>
        <ImageContainer recipe={recipe}></ImageContainer>
        <FilterContainer>{recipe.recipeName}</FilterContainer>
        <ResultContainer>
          <Title>Ingredients</Title>
          <ul>
            {cleanedIngredientList.map((ingredient, index) => (
              <li key={index}>{ingredient}</li>
            ))}
          </ul>
        </ResultContainer>

        <VerticalFlex>
          <YoutubeButton
            href={`https://www.youtube.com/results?search_query=${recipe.recipeName}`}
          >
            Watch the recipe
            <img src="youtube.png" alt="youtube" />
          </YoutubeButton>
          <WhatsappButton href={`whatsapp://send?text=${WhatsappMessage}`}>
            Share on Whatsapp
            <img src="whatsapp.png" alt="whatsapp" />
          </WhatsappButton>
        </VerticalFlex>
      </Body>
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  font-size: 14px;
  max-height: 100vh;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(51, 51, 51, 0.4);
`;
const Head = styled.div`
  color: white;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  height: 80px;
  background-color: #f15d53;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 24px 12px;
  overflow: hidden;
  z-index: 99999;
`;
const BackButton = styled.div`
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;
const ImageContainer = styled.div`
  width: 100%;
  height: 300px;
  background: url(${(props) => props.recipe.image});
  z-index: 100;
  background-position: center;
  background-size: cover;
`;
const Body = styled.div`
  width: 80%;
  margin-top: -10px;

  overflow: auto;
  flex-grow: 1;
  background-color: #fff;
  z-index: 9999;
`;
const FilterContainer = styled.div`
  /* max-width: 100%; */
  display: flex;
  padding: 20px 10px;
  font-size: 28px;
  font-weight: 500;
  justify-content: center;
  background-color: #f1e1c736;
`;

const ResultContainer = styled.div`
  padding: 32px 120px;
  ul {
    padding: 16px;
    font-size: 16px;
  }
`;
const Title = styled.div`
  font-size: 24px;
  font-weight: 500;
`;
const YoutubeButton = styled.a`
  border: 2px solid #ff0000;
  background-color: #fff;
  padding: 10px;
  border-radius: 4px;
  width: 240px;
  justify-content: space-between;
  text-decoration: none;
  color: #000;
  display: flex;
  img {
    width: 30px;
    margin: 0 10px;
  }
  align-items: center;
`;
const WhatsappButton = styled.a`
  margin: 10px 0;
  border: 2px solid #29a71a;
  background-color: #fff;
  padding: 10px;
  border-radius: 4px;
  width: 240px;
  display: flex;
  justify-content: space-between;
  text-decoration: none;
  color: #000;
  img {
    width: 30px;
    margin: 0 10px;
  }
  align-items: center;
`;
const VerticalFlex = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;
export default DetailsCard2;
